<template>
  <NavigationSecondaryTab
    :heading="activeNavMenuLabel"
    class="gtm-secondary-tab-menu"
    gtm-tab-name="menu"
  >
    <ul :key="tabListKey" class="secondary-menu secondary-tab-list">
      <li v-for="(item, index) in activeNavMenu" :key="item._uid">
        <component
          :is="getMobileComponent(item.component)"
          :blok="item"
          :index="index"
        />
      </li>
    </ul>
  </NavigationSecondaryTab>
</template>

<script setup lang="ts">
const mobileNavStore = useMobileNavStore()
const { activeNavMenu, activeNavMenuLabel } = storeToRefs(mobileNavStore)
const tabListKey = computed(() => `${activeNavMenuLabel}-secondary-tab-list`)
function getMobileComponent(componentName: string) {
  switch (componentName) {
    case 'NavigationMenuItem':
    case 'NavigationMenuChild':
      return 'NavigationMenuMobileItem'
    case 'NavigationMenuWrapper':
      return 'NavigationMenuMobileWrapper'
    default:
      return componentName
  }
}
</script>

<style lang="less">
ul.secondary-menu {
  .list-reset();
  .flex-col();
  .align-start();

  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 0 @gutter @gutter-lg;
  margin: @30px 0 0;

  li {
    .block();

    width: 100%;
    margin: 0;

    > div {
      a {
        .font-headings();
        .font-medium();
        .font-lg();
        .block();
        .relative();
        .whitespace-nowrap();

        z-index: 10;
        padding: @gutter 0;
        transition: background-color 0.2s ease-in-out 0.1s;

        @media @tablet {
          padding: @20px 0;
        }

        .icon {
          .inline-block();
          .absolute();

          right: 0;
          top: 50%;
          transform: translate(0, -50%);
        }

        &:link,
        &:visited,
        &:hover,
        &:active {
          color: @color-text;
        }
      }
    }

    &.title {
      padding: 0 0 @3px;
      border: none;
      div {
        .font-black();

        margin: 0;
      }
    }
  }

  ul {
    padding: 0;

    > li.title {
      padding: 0 0 @3px;
    }
  }

  > li > ul {
    margin: @gutter-xl 0 0;
  }

  > li:not(:last-child),
  > li:not(:last-child) > ul,
  li.link:not(:last-child) {
    border-bottom: @2px solid @color-border;
  }

  > li:first-child {
    > ul {
      margin: 0;
    }
  }
}
</style>
